"use client";

import React from "react";

export default function MobileBottomSheet({
  isOpen,
  title,
  onClose,
  children,
  className = "",
}: {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}) {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[90] bg-black/45 md:hidden" onClick={onClose} />
      <section
        className={`editor-panel fixed inset-x-0 bottom-0 z-[100] flex max-h-[82dvh] flex-col overflow-hidden rounded-t-2xl border-t border-white/10 shadow-2xl md:hidden ${className}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="flex justify-center py-2">
          <div className="h-1 w-12 rounded-full bg-white/25" />
        </div>
        <div className="editor-panel-header flex shrink-0 items-center justify-between px-4 pb-3">
          <div className="text-sm font-semibold uppercase tracking-wide text-white">{title}</div>
          <button
            type="button"
            className="rounded-lg p-2 text-white/75 transition-colors hover:bg-white/5 hover:text-white"
            onClick={onClose}
            aria-label="Close"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="m6 6 12 12M18 6 6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
      </section>
    </>
  );
}
